import { useLangContext } from "context/Lang"
import { StatusFlags, StatusMap, StatusType } from "utils/Status"



interface StatusLabelProps{
    status?:number | StatusType

}



export const StatusLabel=({status}:StatusLabelProps)=>{
    
    const {gW}=  useLangContext();

    return <span className={`px-3 py-1 rounded-full text-xs font-bold ${
        status === StatusFlags.ACTIVE ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"
    }`}>
        {gW(StatusMap?.[status as StatusType ])}
    </span>
}